<template>
	<div class="wrapper">
		<div class="weui-msg">
			<div class="weui-msg__icon-area"><i class="weui-icon-success weui-icon_msg"></i></div>
			<div class="weui-msg__text-area">
				<h2 class="weui-msg__title">提交成功</h2>
				<!--<p class="weui-msg__desc">{{resultMsg}}</p>-->
			</div>
			<div class="weui-msg__opr-area">
				<p class="weui-btn-area">
					<!--<button class="weui-btn weui-btn_primary" @click="handlePath('index')">开票首页</button>-->
					<button class="weui-btn weui-btn_default" @click="handlePath('history')">开票历史</button>
				</p>
			</div>
		</div>
	</div>
</template>

<script>
    export default {
        name: "index",
		data () {
            return {
			}
		},
		created () {
		},
		methods:{
            handlePath (where) {
                if (where === 'index'){
                    this.$router.push('receiptOptions')
				} else {
                    this.$router.push('receiptHistory')
				}
			}
		}
    }
</script>

<style scoped lang="stylus">
	.weui-btn-area{
		margin 10px
		.weui-btn{
			width: 100%;
		}
	}
</style>
